import { useContext } from 'react'
import { AuthContext } from './AuthContext'
import type { AuthState } from './AuthContext'

export function useAuth(): AuthState {
  const context = useContext(AuthContext)
  if (!context) throw new Error('useAuth must be used inside <AuthProvider>')
  return context
}
